<template>
  <div class="Content">
    <div class="SearchBar">
      <DefaultSearchInput
        style="width: 873px"
        v-model="searchText"
        placeholder="Название УЦ, ответственный или номер телефона"
      />
      <CustomSelect
        style="width: 231px"
        v-model="selectSort"
        :options="sortTypes"
      />
    </div>
    <div v-if="isLoading" class="loader-container">
      <div class="spinning-loader">
        <div class="spinner-ring ring-1"></div>
        <div class="spinner-ring ring-2"></div>
        <div class="spinner-ring ring-3"></div>
        <div class="center-dot"></div>
      </div>
      <div class="loading-text">Загрузка...</div>
    </div>
    <div v-else>
      <div v-if="filteredCompanies.length > 0" class="ListCompany">
        <div
          v-for="company in filteredCompanies"
          :key="company.id"
          class="Company"
        >
          <div class="Info">
            <div class="TimePanel">
              <div
                v-if="company.status"
                class="Status"
                :class="{
                  Yellow: company.status?.status === 'Ожидает',
                  Green: company.status?.status === 'Одобрено',
                  Red: company.status?.status === 'Отклонено',
                }"
              >
                <p>{{ company.status?.status }}</p>
              </div>
              <div>
                <p>Создано {{ normalDate(company.createdAt) }}</p>
              </div>
              <div>
                <p>Последнее обновление {{ normalDate(company.updatedAt) }}</p>
              </div>
            </div>
            <div
              v-if="
                company.status?.comment &&
                  company.status?.status === 'Отклонено'
              "
              class="StatusComment Red"
            >
              <p>{{ company.status?.comment }}</p>
            </div>
            <div class="Title">
              <h3>{{ company.name }}</h3>
            </div>
            <div class="CourseInfo">
              <p class="FontSize20px">
                Всего {{ company.countCourses }} курсов,
                {{ company.countCoursesApproved }} одобрено,
                <router-link
                  :to="{
                    path: '/admin/org-statuses/catalog',
                    query: {
                      companyName: company.name,
                      nProjectId: company.n_project?.id,
                      statusDefault: 'Ожидает',
                    },
                  }"
                >
                  {{ company.countCoursesAwaiting }} ожидает
                </router-link>
              </p>
            </div>
            <div class="User">
              <p class="FontSize16px FontWeight">Ответственный:</p>
              <p class="FontSize16px">
                {{ getFullNameAgent(company.agent[0]) }}
              </p>
            </div>
            <div class="Contact">
              <p class="FontSize16px">{{ company.email }}</p>
              <p style="min-width: 120px;" class="FontSize16px">
                {{ company.phone }}
              </p>
            </div>
          </div>
          <div class="Buttons">
            <button
              class="btn-n-white"
              @click.native="openUpdateECModal(company)"
            >
              Редактировать
            </button>
            <button
              class="btn-n-white"
              @click.native="
                () => {
                  requestModalShow = 2;
                  modalData.selectCompany = company;
                  disableScroll();
                }
              "
            >
              История статусов
            </button>
            <router-link
              style="color: #1A1A1A"
              class="btn-n-yellow btn-router-link"
              :to="{
                path: '/admin/org-statuses/catalog',
                query: {
                  companyName: company.name,
                  nProjectId: company.n_project?.id,
                },
              }"
            >
              Посмотреть курсы
            </router-link>
          </div>
        </div>
        <Pagination
          class="LastElement"
          :key="`Pagination-${paginationKey}`"
          :dataCounter="filteredCompaniesCount"
          :max_items="maxItems"
          :max_pages_indexes="5"
          :startPage="currentPage"
          @update:page="handlePageChange"
        />
      </div>
      <div v-else class="CompanyNotFound">
        <div class="Info">
          <h2>Компании не найдены</h2>
        </div>
        <p>Возможно вы указали фильтры, для которых не нашлось записей</p>
        <p>Либо сервер в данный момент не смог вам их отправить</p>
      </div>
    </div>
    <DefaultModal
      :key="modalData.key"
      class="ModalEdit"
      v-if="requestModalShow === 1"
      rmtitle="Редактирование"
      rmdesc=""
      :handleModalClose="handleCloseModal"
    >
      <template v-slot:FormBody>
        <span class="ModalInfoTitle">Основная информация</span>
        <label class="AvatarLabel">Фото профиля</label>
        <div
          class="Avatar"
          @click="avatarUploadModalShowed = !avatarUploadModalShowed"
        >
          <div
            v-if="getAvatar != null"
            class="AvatarIMG"
            :style="
              `background: url('${getAvatar}'); background-size: contain;`
            "
          ></div>
          <div v-else class="AvatarIMG"></div>
          <div class="AvatarBG"></div>
        </div>
        <DefaultInput
          v-model="modalData.dfCompanyName"
          @update:modelStatus="modalData.validate.name = $event"
          placeholder="Название"
          :isNull="false"
        />
        <DefaultTextarea
          v-model="modalData.dfCompanyDesc"
          @update:modelStatus="modalData.validate.desc = $event"
          placeholder="Описание"
          :isNull="false"
          :maxLength="1000"
        />
        <span class="ModalInfoTitle">Местонахождение</span>
        <DefaultInput
          v-model="modalData.dfCompanyDistrict"
          @update:modelStatus="modalData.validate.district = $event"
          placeholder="Район"
          :isNull="false"
        />
        <DefaultInput
          v-model="modalData.dfCompanyStreet"
          @update:modelStatus="modalData.validate.street = $event"
          placeholder="Улица"
          :isNull="false"
        />
        <div class="RowInputs">
          <DefaultInput
            v-model="modalData.dfCompanyHouse"
            @update:modelStatus="modalData.validate.house = $event"
            placeholder="Дом"
            :isNull="false"
            :hiddenLabel="false"
          />
          <DefaultInput
            v-model="modalData.dfCompanyStructure"
            placeholder="Строение"
            :hiddenLabel="false"
          />
          <DefaultInput
            v-model="modalData.dfCompanyFloor"
            @update:modelStatus="modalData.validate.floor = $event"
            placeholder="Этаж"
            :isNull="false"
            :hiddenLabel="false"
          />
          <DefaultInput
            v-model="modalData.dfCompanyOffice"
            placeholder="Офис"
            :hiddenLabel="false"
          />
        </div>
        <DefaultTextarea
          v-model="modalData.dfCompanyOrientir"
          @update:modelStatus="modalData.validate.orientir = $event"
          placeholder="Опишите ориентир, чтобы студенты вас смогли найти"
          :maxLength="1000"
        />
        <DefaultInput
          v-model="modalData.dfCompanyYandexMapLink"
          @update:modelStatus="modalData.validate.yandexMapLink = $event"
          placeholder="Ссылка на Яндекс.Карты"
          type="yandexMap"
        />
        <span class="ModalInfoTitle">Контактная информация</span>
        <DefaultInput v-model="modalData.dfCompanySite" placeholder="Сайт" />
        <DefaultInput
          v-model="modalData.dfCompanyPhone"
          placeholder="Телефон"
        />
        <DefaultInput
          v-model="modalData.dfCompanyEmail"
          @update:modelStatus="modalData.validate.email = $event"
          placeholder="Электронная почта"
          type="email"
        />
        <div
          class="Socials"
          v-for="(social, index) in modalData.dfCompanySocials"
          :key="social.id"
        >
          <DefaultInput
            v-model="social.link"
            :placeholder="index === 0 ? 'Соцсети' : ''"
          />
          <div
            v-show="index > 0"
            class="Close"
            @click="deleteSocial(index)"
          ></div>
        </div>
        <button
          style="width: 180px"
          class="btn-n-white-no-border"
          @click="addSocial()"
        >
          Добавить соцсеть
        </button>
        <span class="ModalInfoTitle">Статус модерации</span>
        <CustomSelect
          v-model="modalData.dfCompanyStatus"
          :options="statuses"
          placeholder="Выберите статус"
          label="Статус*"
        />
        <DefaultTextarea
          v-show="modalData.dfCompanyStatus === 'Отклонено'"
          v-model="modalData.dfCompanyStatusComment"
          @update:modelStatus="modalData.validate.statusComment = $event"
          label="Причина отклонения"
        />
      </template>
      <template v-slot:ButtonsSection>
        <button
          style="font-size: 16px; height: 48px"
          :class="{
            'btn-n-yellow': validateUpdateCompanyModal,
            'btn-n-yellow-disabled': !validateUpdateCompanyModal,
          }"
          @click.native="saveCompany"
        >
          Сохранить изменения
        </button>
        <button
          style="font-size: 16px; height: 48px"
          class="btn-n-white-no-border"
          @click.native="handleCloseModal"
        >
          Отменить изменения
        </button>
      </template>
    </DefaultModal>
    <DefaultModal
      class="ModalStatuses"
      v-show="requestModalShow === 2"
      rmtitle="История статусов"
      rmdesc=""
      :handleModalClose="handleCloseModal"
    >
      <template v-slot:FormBody>
        <div v-if="modalData.selectCompany?.status" class="ModalBodyComponents">
          <div class="StatusInfo">
            <div
              class="Status"
              :class="{
                Yellow: modalData.selectCompany?.status?.status === 'Ожидает',
                Green: modalData.selectCompany?.status?.status === 'Одобрено',
                Red: modalData.selectCompany?.status?.status === 'Отклонено',
              }"
            >
              <p>{{ modalData.selectCompany?.status?.status }}</p>
            </div>
            <div class="FullDate">
              <p class="FontSize16px">
                {{ normalDateTime(modalData.selectCompany?.status.createdAt) }}
              </p>
            </div>
          </div>
          <div class="Vector"></div>
          <DefaultInput
            v-model="dateFilterStatus"
            placeholder="Дата статуса"
            type="date"
            :isValidate="false"
          />
          <div class="Statuses">
            <div v-for="status in filteredStatuses" :key="status.id">
              <div class="StatusInfo">
                <div
                  class="Status"
                  :class="{
                    Yellow: status.status === 'Ожидает',
                    Green: status.status === 'Одобрено',
                    Red: status.status === 'Отклонено',
                  }"
                >
                  <p>{{ status.status }}</p>
                </div>
                <div class="FullDate">
                  <p class="FontSize16px">
                    {{ normalDateTime(status.createdAt) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <p class="FontSize16px">В данный момент история статусов пустая</p>
        </div>
      </template>
      <template v-slot:ButtonsSection>
        <button
          class="btn-n-yellow FontSize16px"
          @click.native="handleCloseModal"
        >
          Закрыть
        </button>
      </template>
    </DefaultModal>
    <DefaultModal
      v-show="requestModalShow === 3"
      rmtitle="Изменения успешно сохранены"
      rmdesc=""
      :handleModalClose="handleCloseModal"
    >
      <template v-slot:ButtonsSection>
        <button
          style="font-size: 16px; height: 48px"
          class="btn-n-yellow"
          @click.native="handleCloseModal"
        >
          Принять
        </button>
      </template>
    </DefaultModal>
    <div
      v-if="avatarUploadModalShowed"
      class="AvatarUploadModalWrapper"
      @click.self="avatarUploadModalShowed = !avatarUploadModalShowed"
    >
      <div class="AvatarUploadModal">
        <div class="AUContent">
          <div class="AUTitle noselect">
            <span>{{
              $t("pages.ec_edit.form.avatar_upload_modal.title")
            }}</span>
            <div
              class="Close"
              @click.self="avatarUploadModalShowed = !avatarUploadModalShowed"
            ></div>
          </div>

          <ImageCropper :getResult="getCroppedAvatar" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultSearchInput from "@/components/OctaUI/Inputs/DefaultSearchInput.vue";
import DefaultInput from "@/components/OctaUI/Inputs/DefaultInput.vue";
import DefaultTextarea from "@/components/OctaUI/Inputs/DefaultTextarea.vue";
import CustomSelect from "@/components/OctaUI/Selects/CustomSelect.vue";
import Pagination from "@/components/OctaUI/Pagination.vue";
import DefaultModal from "@/components/DefaultModal";
import ImageCropper from "@/components/ImageCropper";

import { getCompanyList, updateCompany } from "@/api/company.js";
import { ElNotification } from "element-plus";
import { setShortInfo } from "@/api/company.js";
import { transformUrl } from "@/utils/transformUrl.js";

import "@/assets/css/Repainting/Buttons.css";

export default {
  components: {
    DefaultSearchInput,
    DefaultInput,
    DefaultTextarea,
    CustomSelect,
    Pagination,
    DefaultModal,
    ImageCropper,
  },
  data() {
    return {
      companies: [],

      // Данные для (пагинации и лоадера) - две подружки
      isLoading: true,
      filteredCompaniesCount: 0,
      paginationKey: Date.now(),
      currentPage: 1,
      maxItems: 8,

      // Данные для модалки
      scrollPosition: 0,
      requestModalShow: null,
      avatarUploadModalShowed: false,
      modalData: {
        key: 0,
        selectCompany: null,
        avatar: null,

        dfCompanyName: null,
        dfCompanyDesc: null,
        dfCompanyStatus: null,
        dfCompanyStatusComment: null,
        dfCompanyDistrict: null,
        dfCompanyStreet: null,
        dfCompanyHouse: null,
        dfCompanyStructure: null,
        dfCompanyFloor: null,
        dfCompanyOffice: null,
        dfCompanyOrientir: null,
        dfCompanySite: null,
        dfCompanyPhone: null,
        dfCompanyEmail: null,
        dfCompanySocials: [],
        dfCompanyYandexMapLink: null,

        validate: {
          name: false,
          desc: false,
          district: false,
          street: false,
          house: false,
          floor: false,
          orientir: false,
          email: false,
          statusComment: false,
          yandexMapLink: false,
        },
      },

      // Сообщения
      msg: {
        title: {
          serverError: "Извините, произошла ошибка на сервере",
        },
        form: {
          error: {
            title: "Упс!",
            type: "error",
            position: "bottom-right",
            customClass: "ELDefaultNotification",
          },
        },
      },

      // Данные для фильтрации
      searchText: "",
      dateFilterStatus: null,

      // Данные для сортировки
      selectSort: "countCoursesAwaiting-dec",
      sortTypes: [
        { value: "countCoursesAwaiting-dec", name: "По убыванию ожидающих курсов" },
        { value: "countCoursesAwaiting-inc", name: "По возрастанию ожидающих курсов" },
        { value: "countCourses-dec", name: "По убыванию количества курсов" },
        { value: "countCourses-inc", name: "По возрастанию количества курсов" },
      ],

      // Данные для селектора
      statuses: [
        { value: "Ожидает", name: "Ожидает" },
        { value: "Одобрено", name: "Одобрено" },
        { value: "Отклонено", name: "Отклонено" },
      ],
    };
  },
  mounted() {
    this.getCompanyList();
  },
  watch: {
    "modalData.dfCompanyStatus"() {
      if (this.modalData.dfCompanyStatus !== "Отклонено")
        this.modalData.dfCompanyStatusComment = null;
    },
  },
  computed: {
    getAvatar() {
      if (!this.modalData.selectCompany?.n_project) {
        return null;
      }

      if (this.modalData.avatar != null) {
        return this.modalData.avatar;
      }

      if (this.modalData.selectCompany.n_project.avatar_url != null) {
        return transformUrl(this.modalData.selectCompany.n_project.avatar_url);
      }

      return null;
    },
    validateUpdateCompanyModal() {
      return (
        this.modalData.validate.name &&
        this.modalData.validate.desc &&
        this.modalData.validate.district &&
        this.modalData.validate.street &&
        this.modalData.validate.house &&
        this.modalData.validate.floor &&
        this.modalData.validate.orientir &&
        this.modalData.validate.email &&
        this.modalData.validate.statusComment &&
        this.modalData.validate.yandexMapLink
      );
    },
    filteredCompanies() {
      let companies = [...this.companies];
      const [key, sort_type] = this.selectSort.split("-");

      // Сортировка
      companies.sort((param1, param2) => {
        let value1 = param1[key];
        let value2 = param2[key];

        // Строчки
        if (typeof value1 === "string") {
          value1 = value1.toLowerCase();
          value2 = value2.toLowerCase();
          return sort_type === "inc"
            ? value1.localeCompare(value2)
            : value2.localeCompare(value1);
        }

        // Числа
        return sort_type === "inc" ? value1 - value2 : value2 - value1;
      });

      // Фильтрация
      companies = companies.filter((company) => {
        // Поиск по названию
        if (
          company.name.toLowerCase().includes(this.searchText.toLowerCase())
        ) {
          return true;
        }

        // Поиск по ответственному
        if (
          this.getFullNameAgent(company.agent[0])
            .toLowerCase()
            .includes(this.searchText.toLowerCase())
        ) {
          return true;
        }

        // Поиск по номеру телефона
        if (company.n_project?.contacts) {
          // Достаём телефон и email из контактов
          let contacts = company.n_project.contacts.split("{%;%}");

          // Проверяем, подходит ли телефон
          if (contacts[0].toLowerCase().includes(this.searchText.toLowerCase()))
            return true;
        }

        return false;
      });

      // Перенаправление на 1 страницу, если количество курсов меньше текущей страницы
      if ((this.currentPage - 1) * this.maxItems >= companies.length) {
        this.paginationKey++;
        this.handlePageChange(1);
      }

      // Записываем фактическое количество курсов после фильтрации до slice
      this.filteredCompaniesCount = companies.length;

      // Возвращаем курсы для данной страницы(currentPage)
      return companies.slice(
        this.maxItems * (this.currentPage - 1),
        this.maxItems * (this.currentPage - 1) + this.maxItems
      );
    },
    filteredStatuses() {
      let statuses = [];

      if (this.modalData.selectCompany?.n_project?.Project_Job_Statuses) {
        // Фильтрация
        statuses = this.modalData.selectCompany.n_project?.Project_Job_Statuses.filter(
          (status) => {
            let dateStr = this.normalDate(status.createdAt);
            // По дате
            if (
              !this.dateFilterStatus ||
              dateStr.includes(this.dateFilterStatus)
            ) {
              return true;
            }

            return false;
          }
        );
      }

      return statuses;
    },
  },
  methods: {
    async getCompanyList() {
      try {
        this.isLoading = true;
        let countRequest = 0;
        let dataLastRequest = [];
        this.companies = [];

        // Загружаем список компаний пакетами по maxItems
        while (countRequest === 0 || dataLastRequest.length > 0) {
          dataLastRequest = (
            await getCompanyList(this.maxItems, countRequest * this.maxItems)
          ).data;

          // Переводим некоторые данный в удобный вид
          for (const company of dataLastRequest) {
            if (company?.n_project == null) {
              company.status = null;
              company.countCourses = 0;
              company.countCoursesApproved = 0;
              company.countCoursesAwaiting = 0;

              continue;
            }

            // Сортируем статусы компании по возврастанию
            company.n_project.Project_Job_Statuses.sort((a, b) => a.id - b.id);
            
            company.status = this.getLastElement(
              company.n_project.Project_Job_Statuses
                ? company.n_project.Project_Job_Statuses
                : []
            );

            company.countCourses = this.getCountCourses(company.n_project.Jobs);

            company.countCoursesApproved = this.getCountCoursesApproved(
              company.n_project.Jobs
            );

            company.countCoursesAwaiting = this.getCountCoursesAwaiting(
              company.n_project.Jobs
            );

            if (company.n_project?.contacts) {
              const contacts = company.n_project.contacts.split("{%;%}");
              if (contacts.length === 2) {
                company.phone = contacts[0];
                company.email = contacts[1];
              } else {
                company.phone = null;
                company.email = null;
              }
            }
          }

          this.companies.push(...dataLastRequest);

          // Если произошла загрузка первого пакета - убираем лоадер
          if (countRequest === 0) {
            this.isLoading = false;
          }

          countRequest++;
        }
      } catch (e) {
        console.log(e);
      }
    },
    openUpdateECModal(company) {
      // Открываем модальное окно
      this.requestModalShow = 1;
      // Заполняем известными нам данными
      this.modalData.selectCompany = company;
      this.modalData.avatar = null;
      this.modalData.dfCompanyName = company.name;
      this.modalData.dfCompanyDesc = company.n_project?.description;
      this.modalData.dfCompanyStatus = company.status
        ? company.status.status
        : "Ожидает";
      this.modalData.dfCompanyStatusComment = null;
      this.modalData.dfCompanyOrientir = company.n_project?.orientir;
      this.modalData.dfCompanySite = company.n_project?.site;
      this.modalData.dfCompanyPhone = company.phone;
      this.modalData.dfCompanyEmail = company.email;
      this.modalData.dfCompanyYandexMapLink = company.n_project?.yandex_map_link;

      // Разбивание адресс на компоненты и заполняем
      let address = "";
      if (company.n_project?.address)
        address = company.n_project.address.split("{%;%}");
      // Если address существует и имеет запись в массиве - заполняем, иначе пустая строка
      this.modalData.dfCompanyDistrict =
        address?.[0] !== null && address?.[0] !== undefined ? address?.[0] : "";
      this.modalData.dfCompanyStreet =
        address?.[1] !== null && address?.[1] !== undefined ? address?.[1] : "";
      this.modalData.dfCompanyHouse =
        address?.[2] !== null && address?.[2] !== undefined ? address?.[2] : "";
      this.modalData.dfCompanyStructure =
        address?.[3] !== null && address?.[3] !== undefined ? address?.[3] : "";
      this.modalData.dfCompanyFloor =
        address?.[4] !== null && address?.[4] !== undefined ? address?.[4] : "";
      this.modalData.dfCompanyOffice =
        address?.[5] !== null && address?.[5] !== undefined ? address?.[5] : "";

      // Получаем массив соцсетей, если массив пуст, добавляем в него один пустой объект соцсети
      this.modalData.dfCompanySocials =
        company.n_project?.n_project_socials.length > 0
          ? Array.from(company.n_project?.n_project_socials)
          : [{ id: null, link: "" }];

      // Убираем скрол
      this.disableScroll();
    },
    getCroppedAvatar(res) {
      this.modalData.avatar = res;
      this.avatarUploadModalShowed = false;
    },
    getLastElement(array) {
      if (array.length === 0) return null;

      return array[array.length - 1];
    },
    getFullNameAgent(agent) {
      return `${agent.surname ? agent.surname : ""} ${
        agent.name ? agent.name : ""
      } ${agent.patronymic ? agent.patronymic : ""}`;
    },
    getCountCourses(jobs) {
      return jobs.length;
    },
    getCountCoursesApproved(jobs) {
      let counter = 0;

      for (const job of jobs) {
        const status = this.getLastElement(job.Project_Job_Statuses);
        if (status?.status === "Одобрено") counter++;
      }

      return counter;
    },
    getCountCoursesAwaiting(jobs) {
      let counter = 0;

      for (const job of jobs) {
        const status = this.getLastElement(job.Project_Job_Statuses);
        if (status?.status === "Ожидает") counter++;
      }

      return counter;
    },
    handlePageChange(page) {
      this.currentPage = page;
    },
    deleteSocial(index) {
      this.modalData.dfCompanySocials.splice(index, 1);
    },
    addSocial() {
      this.modalData.dfCompanySocials.push({
        id: null,
        link: "",
      });
    },
    async saveCompany() {
      try {
        /* Подготавливаем данные */
        let formData = new FormData();

        let textData = {
          name: this.modalData.dfCompanyName,
          description: this.modalData.dfCompanyDesc,
          status: this.modalData.dfCompanyStatus,
          statusComment: this.modalData.dfCompanyStatusComment,
          address: `${this.modalData.dfCompanyDistrict}{%;%}${this.modalData.dfCompanyStreet}{%;%}${this.modalData.dfCompanyHouse}{%;%}${this.modalData.dfCompanyStructure}{%;%}${this.modalData.dfCompanyFloor}{%;%}${this.modalData.dfCompanyOffice}`,
          orientir: this.modalData.dfCompanyOrientir,
          site: this.modalData.dfCompanySite,
          phone: this.modalData.dfCompanyPhone,
          email: this.modalData.dfCompanyEmail,
          social_links: [],
          yandex_map_link: this.modalData.dfCompanyYandexMapLink
        };

        // Если соцсеть имеет не пустую link, то добавляем в массив соцсетей
        for (const social of this.modalData.dfCompanySocials) {
          if (social.link) textData.social_links.push(social);
        }

        // Добавляем в formData textData(в виде req_data)
        formData.append("req_data", JSON.stringify(textData));

        // Добавляем в formData avatar(в виде file)
        if (this.modalData.avatar != null) {
          const file = this.dataURLtoFile(this.modalData.avatar, "avatar.png");
          formData.append("file", file);
        }

        let reqResponse = await updateCompany(
          this.modalData.selectCompany.id,
          formData
        );

        if (reqResponse.status != 200) {
          throw new Error("Ошибка");
        }

        // Обновляем данные компаний на странице до актуальных
        this.getCompanyList();

        this.requestModalShow = 3;
      } catch (e) {
        console.log(e);
        ElNotification({
          ...this.msg.form.error,
          message: this.msg.title.serverError,
        });
      }

      this.requestModalShow = 3;
    },
    dataURLtoFile(dataUrl, filename) {
      const arr = dataUrl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1]; // например, image/png
      const bstr = atob(arr[1]); // декодируем base64
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    normalDate(date) {
      const newDate = new Date(date);
      const day = String(newDate.getDate()).padStart(2, "0");
      const month = String(newDate.getMonth() + 1).padStart(2, "0");
      const year = newDate.getFullYear();

      return `${day}.${month}.${year}`;
    },
    normalDateTime(date) {
      const newDate = new Date(date);
      const day = String(newDate.getDate()).padStart(2, "0");
      const month = String(newDate.getMonth() + 1).padStart(2, "0");
      const year = newDate.getFullYear();
      const hours = String(newDate.getHours()).padStart(2, "0");
      const minutes = String(newDate.getMinutes()).padStart(2, "0");
      const seconds = String(newDate.getSeconds()).padStart(2, "0");

      return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    },
    handleCloseModal() {
      this.requestModalShow = null;
      // Обновляем состояние полей
      this.modalData.key++;

      this.dateFilterStatus = null;

      this.enableScroll();
    },
    disableScroll() {
      // Запоминаем позицию скролла
      this.scrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      // Рассчитываем ширину скроллбара
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      // Блокируем скролл
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.top = `-${this.scrollPosition}px`;
      document.body.style.width = "100%";
      document.body.style.height = "100%";

      // Компенсируем ширину скроллбара
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      // Для iOS Safari
      document.body.style.overscrollBehavior = "none";
    },
    enableScroll() {
      // Восстанавливаем скролл
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.height = "";
      document.body.style.paddingRight = "";

      // Возвращаем позицию скролла
      window.scrollTo(0, this.scrollPosition);

      // Для iOS
      document.body.style.overscrollBehavior = "";
    },
  },
};
</script>

<style scoped>
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
}
.ModalEdit:deep(.RMView) {
  width: 752px;
}
.ModalStatuses:deep(.RMView) {
  width: 352px;
}
.ModalBodyComponents {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
  overflow-y: auto;
}
.StatusInfo {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  padding-right: 24px;
  flex-direction: row;
  justify-content: space-between;
}
.Content .SearchBar {
  position: relative;
  display: flex;

  flex-direction: row;

  margin-top: 40px;
  gap: 25px;
}
.Content .ListCompany {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  margin-top: 24px;
}
.Content h3 {
  font-family: "Involve";
  font-weight: 500;
  font-size: 24px;
  line-height: 130%;
  color: #232323;

  word-break: break-word;
}
.Content p.FontSize16px:not(.FontWeight) {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  position: relative;
  width: fit-content;
  flex-basis: auto;
  flex-shrink: 1;
  word-break: break-word;
}
.Content p.FontSize16px.FontWeight {
  flex-shrink: 0;
}
.Content p {
  font-family: "Involve";
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #666666;
}
.Content a {
  font-family: "Involve";
  font-weight: 500;
  line-height: 150%;
  color: #666666;
}
.FontSize16px {
  font-size: 16px !important;
}
.FontSize20px {
  font-size: 20px !important;
}
.FontWeight {
  font-weight: 700 !important;
}
.ListCompany .Company {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  padding: 24px;
  gap: 24px;

  background: #ffffff;
  box-shadow: 0px 16px 32px -4px rgba(12, 12, 13, 0.1),
    0px 4px 4px -4px rgba(12, 12, 13, 0.05);
  border-radius: 16px;
}
.Content .CompanyNotFound {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  padding: 24px;
  gap: 24px;

  background: #ffffff;
  box-shadow: 0px 16px 32px -4px rgba(12, 12, 13, 0.1),
    0px 4px 4px -4px rgba(12, 12, 13, 0.05);
  border-radius: 16px;
}
.Company .Info {
  position: relative;
  display: flex;

  width: 901px;
  height: fit-content;

  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
.Info .TimePanel {
  position: relative;
  display: flex;

  width: 100%;
  height: 29px;

  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  align-content: flex-start;
  gap: 8px;
}
.Info .StatusComment {
  position: relative;
  display: flex;

  width: fit-content;
  max-width: 548px;
  height: fit-content;

  flex-direction: column;
  align-items: center;
  padding: 4px 12px;
  gap: 10px;

  border-radius: 4px;

  margin-top: 16px;
  word-break: break-word;
}
.Info .Title {
  margin-top: 16px;
}
.Info .CourseInfo {
  margin-top: 8px;
}
.Info .User {
  position: relative;
  display: flex;

  flex-direction: row;
  gap: 4px;
  margin-top: 8px;
}
.Info .Contact {
  position: relative;
  display: flex;

  flex-direction: row;
  gap: 16px;
}
.Statuses {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
}
.ModalStatuses:deep(.RMBody) {
  overflow-y: auto;
}
.Status {
  position: relative;
  display: flex;

  width: fit-content;
  height: 29px;

  flex-direction: row;
  align-items: center;
  padding: 4px 12px;
  gap: 10px;

  border-radius: 4px;
}
.FullDate {
  position: relative;
  display: flex;

  width: fit-content;
  height: 29px;

  align-items: center;
}
.Yellow {
  background: #fff0c3 !important;
}
.Yellow p {
  color: #876500 !important;
}
.Green {
  background: #e4ffea !important;
}
.Green p {
  color: #28a745 !important;
}
.Red {
  background: #ffe8e9 !important;
}
.Red p {
  color: #dc3545 !important;
}
.Company .Buttons {
  position: relative;
  display: flex;

  width: 155px;
  height: fit-content;

  flex-direction: column;
  margin-top: auto;
  gap: 8px;
}
.LastElement {
  margin-top: 16px;
}
.Vector {
  width: 100%;
  height: 0px;
  border: 1.5px solid #e0e0e0;
}
.AvatarUploadModalWrapper {
  position: fixed;
  display: flex;

  inset: 0;

  width: 100%;
  height: 100svh;

  background-color: rgba(26, 26, 26, 0.6);
  backdrop-filter: blur(10px);

  z-index: 2001;
}
.AvatarUploadModal {
  position: relative;
  display: flex;

  margin: auto;
  padding: 40px;

  min-width: 0;
  width: 500px;
  max-width: 95%;

  height: fit-content;
  max-height: 95%;

  border-radius: 24px;
  overflow-y: auto;

  background-color: white;
}
.Avatar {
  position: relative;
  display: block;

  cursor: pointer;

  margin-left: 16px;
  margin-bottom: 4px;

  width: 56px;
  height: 56px;

  border-radius: 100%;
  overflow: hidden;
}
.AvatarBG {
  position: absolute;
  display: block;

  inset: 0;

  width: 100%;
  height: 100%;

  background-color: #f8f8f8;

  z-index: 1;
}
.AvatarIMG {
  position: absolute;
  display: block;

  inset: 0;

  width: 100%;
  height: 100%;

  background: url("./../../assets/img/ReDesign/interface_icons/UserDefaultAvatar.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 24px;

  z-index: 2;
}
.AvatarLabel {
  position: relative;
  display: flex;

  width: fit-content;
  height: 18px;

  margin-bottom: -12px;

  flex-direction: row;
  align-items: center;
  padding: 0px 16px;
  gap: 10px;
  font-family: "Involve";
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  color: #666666;
}
.AUContent {
  position: relative;
  display: flex;

  min-width: 0%;
  width: 100%;

  height: fit-content;
  max-height: 100%;

  flex-direction: column;
  justify-content: flex-start;
  gap: 24px;
}
.AUTitle > * {
  margin: auto 0%;
}
.AUTitle {
  position: relative;
  display: flex;

  width: auto;
  max-width: 100%;

  flex-direction: row;
  justify-content: space-between;
  gap: 10px;

  font-family: "Involve";
  font-weight: 500;
  font-size: 24px;
  line-height: 130%;
  letter-spacing: 0%;

  color: #1a1a1a;
}
.Close {
  position: relative;
  display: block;

  width: 40px;
  height: 40px;

  background: url("./../../assets/img/ReDesign/interface_icons/close_modal_16px.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px;

  border-radius: 8px;
  transition: 0.3s;

  flex-shrink: 0;
}
.Close:hover {
  transition: 0.3s;
  background-color: #f8f8f8;
}
.ModalInfoTitle {
  position: relative;
  display: inline;
  width: fit-content;
  max-width: 100%;
  height: fit-content;
  font-family: "Involve";
  font-weight: 500;
  font-size: 18px;
  line-height: 130%;
  letter-spacing: 0%;
  color: #1a1a1a;
}
.RowInputs {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;

  gap: 8px;
}
.Socials {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  align-items: center;

  gap: 8px;
}
.loader-container {
  text-align: center;
  margin-top: 80px;
}
.spinning-loader {
  position: relative;
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
}
.spinner-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  animation: spin 2s linear infinite;
}
.ring-1 {
  border: 3px solid transparent;
  border-top: 3px solid #f9d773e5;
  border-right: 3px solid #f9d773e5;
}
.ring-2 {
  border: 3px solid transparent;
  border-top: 3px solid #f9d77333;
  border-right: 3px solid #f9d77333;
  width: 70%;
  height: 70%;
  top: 15%;
  left: 15%;
  animation-duration: 1.5s;
  animation-direction: reverse;
}
.ring-3 {
  border: 3px solid transparent;
  border-top: 3px solid #f9d7731a;
  border-right: 3px solid #f9d7731a;
  width: 50%;
  height: 50%;
  top: 25%;
  left: 25%;
  animation-duration: 1s;
}
.center-dot {
  position: absolute;
  width: 12px;
  height: 12px;
  background: #f9d773e5;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: pulse-center 2s infinite ease-in-out;
}
.loading-text {
  color: #000000;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 2px;
  animation: pulse 2s infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  0%,
  100% {
    opacity: 0.7;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
}
@keyframes pulse-center {
  0%,
  100% {
    transform: translate(-50%, -50%) scale(1);
    box-shadow: 0 0 10px #f9d773e5;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
    box-shadow: 0 0 20px #f9d773e5, 0 0 30px #f9d77333;
  }
}
</style>
